import { render, staticRenderFns } from "./FilterTagSelection.vue?vue&type=template&id=8e0fa22c&scoped=true&"
import script from "./FilterTagSelection.vue?vue&type=script&lang=ts&"
export * from "./FilterTagSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0fa22c",
  null
  
)

export default component.exports